import {
  Badge,
  Button,
  ButtonProps,
  Icon,
  Tooltip,
} from '@infotech-soe/erp-ui-kit';
import classNames from 'classnames';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { createUseStyles } from 'react-jss';

interface Props extends Pick<
  ButtonProps,
  'className' | 'disabled' | 'onClick'
> {
  unread: number;
}

const messages = defineMessages({
  hint: { id: 'core.notification.title', defaultMessage: 'Notifications' },
});

const useStyles = createUseStyles({
  parent: {
    position: 'relative',
  },
  count: {
    right: '20%',
    top: '20%',
  },
});

const NotificationsButton = ({
  className,
  disabled,
  unread,
  onClick,
}: Props): React.JSX.Element => {
  const classes = useStyles();
  const { formatMessage } = useIntl();

  return (
    <Tooltip disableFocusListener label={formatMessage(messages.hint)}>
      <Button
        className={classNames(classes.parent, className)}
        disabled={disabled}
        rounded={false}
        variant="ondark"
        onClick={onClick}
      >
        <Icon name="bell" />
        {unread > 0 && <Badge className={classes.count}>{unread}</Badge>}
      </Button>
    </Tooltip>
  );
};

export default NotificationsButton;
